import ApplicationModel, { attr } from '../ApplicationModel';
import { type SearchDocumentAttributes } from './generated/SearchDocumentAttributes';
import { model } from '../modelBuilder';
import {
  type ModelName,
  type RecordIdentifier,
} from 'javascripts/shared-types';

interface SearchDocument extends SearchDocumentAttributes {
  searchableType: ModelName;
}

@model
class SearchDocument extends ApplicationModel {
  // Start auto-generated
  static typename: 'SearchDocument' = 'SearchDocument';
  get typename(): 'SearchDocument' {
    return 'SearchDocument';
  }

  static internalTypename: 'Search::Document' = 'Search::Document';
  get internalTypename(): 'Search::Document' {
    return 'Search::Document';
  }

  static filterType = 'SearchDocumentFilters!';
  static filters = {
    query: 'String!',
    projectId: 'ID',
    searchableType: '[String!]',
  };

  static fields = {
    name: attr({ readable: true }),
    projectId: attr({ readable: true }),
    searchableId: attr({ readable: true }),
    searchableType: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    url: attr({ readable: true }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    searchable: attr.belongsTo({
      readable: true,
      typename: [
        'BusinessModelComponent',
        'Comment',
        'Competitor',
        'Epic',
        'Feature',
        'Goal',
        'Idea',
        'IdeaTheme',
        'Initiative',
        'KeyResult',
        'Page',
        'Persona',
        'Project',
        'ProjectStrategyComponent',
        'Release',
        'ReleasePhase',
        'Requirement',
        'Task',
      ],
    }),
  };
  // End auto-generated

  get searchableIdentifier(): RecordIdentifier {
    return `${this.searchableType}-${this.searchableId}`;
  }
}

export default SearchDocument;
